import React from "react";

/**
 * @desc 마케팅 목적의 개인정보 수집 및 이용동의
 * @returns
 */
const MarketingTerms = () => {
  return (
    <div class="content">
      <table>
        <tbody>
          <tr>
            <td width="141">
              <p>
                <strong>수집/이용 목적</strong>
              </p>
            </td>
            <td width="227">
              <p>
                <strong>개인정보 항목</strong>
              </p>
            </td>
            <td width="233">
              <p>
                <strong>보유기간</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td width="141">
              <p>서비스 안내,</p>
              <p>광고성 정보 제공 및 맞춤형 서비스 제안</p>
            </td>
            <td width="227">
              <p>이름, 이메일 주소, 휴대폰 번호</p>
            </td>
            <td width="233">
              <p>INAVI Maps 서비스 탈퇴 시 파기</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MarketingTerms;
